/*=========================================================================================
  File Name: moduleMapActions.js
  Description: Map Module Actions
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/
import Api from "@/helpers/api.js";

export default {
	/**
	 * Fetches group items from the server.
	 * @param {Object} data - The data object containing the parameters for the fetch request.
	 * @param {number} [data.page] - The page number for pagination.
	 * @param {number} [data.quantity] - The number of items per page.
	 * @param {Array} [data.ids] - The array of group IDs to filter by.
	 * @param {string} [data.name] - The name of the group to filter by.
	 * @param {string} [data.city] - The city of the group to filter by.
	 * @param {string} [data.hour_init] - The start hour of the group to filter by.
	 * @param {string} [data.hour_end] - The end hour of the group to filter by.
	 * @param {Array} [data.fields] - The array of fields to include in the response. can be any of the following: id, name, description, city, country, cx, cy, address, dirtrad, hour_init, hour_end, company_id, serviforms_group_id
	 * @returns {Promise} A promise that resolves with the fetched group items or rejects with an error.
	 */
	fetchGroupItems({commit}, data) {
		const payload = {
			page: data.page || null,
			quantity: data.quantity || null,
			id: data.ids ? data.ids : [],
			name: data.name ? data.name : "",
			description: "",
			city: data.city ? data.city : "",
			country: "",
			address: "",
			dirtrad: "",
			hour_init: data.hour_init ? data.hour_init : "",
			hour_end: data.hour_end ? data.hour_end : "",
			order_by: "name",
		};

		if (data.fields && data.fields.length > 0) {
			payload.fields = data.fields;
		}

		return new Promise((resolve, reject) => {
			Api.post("/group/filter", payload)
				.then((response) => {
					commit("SET_GROUPS", response.data.records);
					resolve(response.data);
				})
				.catch((error) => {
					reject(error);
				});
		});
	},
	createGroup({commit}, group) {
		return new Promise((resolve, reject) => {
			Api.post("/group", group)
				.then((response) => {
					group.id = response.data.id;
					commit("ADD_GROUP", group);
					resolve(group);
				})
				.catch((error) => {
					reject(error);
				});
		});
	},
	updateGroup({commit}, group) {
		return new Promise((resolve, reject) => {
			Api.put(`/group/${group.id}`, group)
				.then((response) => {
					commit("UPDATE_GROUP", response.data);
					resolve(response);
				})
				.catch((error) => {
					reject(error);
				});
		});
	},
	removeGroup({commit}, groupId) {
		return new Promise((resolve, reject) => {
			Api.delete(`/group/${groupId}`)
				.then((response) => {
					commit("REMOVE_GROUP", groupId);
					resolve(response);
				})
				.catch((error) => {
					reject(error);
				});
		});
	},
	addGroupActivity({commit}, groupItem) {
		commit("ADD_GROUP_ACTIVITY", groupItem);
	},
	removeGroupActivity({commit}, groupItem) {
		commit("REMOVE_GROUP_ACTIVITY", groupItem);
	},
	cleanGroupActivity({commit}, groupItem) {
		commit("CLEAN_GROUP_ACTIVITY");
	},
	getGroupsByFilter({commit}, data) {
		return new Promise((resolve, reject) => {
			const payload = {
				page: data.page || 1,
				quantity: data.quantity || 1000,
				fields: data.fields || [],
				id: data.ids || [],
				name: data.name || "",
				description: data.description || "",
				city: data.city || "",
				country: data.country || "",
				address: data.address || "",
				dirtrad: data.dirtrad || "",
				hour_init: data.hour_init || "",
				hour_end: data.hour_end || "",
				order_by: data.order_by || "name",
			};
			Api.post("/group/filter", payload)
				.then((res) => {
					commit("SET_GROUPS_ACTIVITY", res.data.records);
					resolve(res);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},
};
